import { W as WuiProgressBar$1, d as defineCustomElement$1 } from './p-kLhi_GFu.js';

const WuiProgressBar = WuiProgressBar$1;
const defineCustomElement = defineCustomElement$1;

export { WuiProgressBar, defineCustomElement };
